import React, {ComponentProps} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

export const HeaderWithIcon: React.FC<ComponentProps<typeof FontAwesomeIcon>> = ({children, style, ...props}) => {
  return <h3>
    <FontAwesomeIcon {...props} style={{...style, marginRight: '.65rem'}}/>
    {children}
  </h3>;
}
